import React, { useState } from "react";
import {
	FormControl,
	Select,
	MenuItem,
	TextField,
	Box,
	Typography,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

const LicensingTerm = ({ formik }) => {
	const [showCustomInput, setShowCustomInput] = useState(false);
	const [customFromDate, setCustomFromDate] = useState(null);
	const [customToDate, setCustomToDate] = useState(null);

	// Handle select change
	const handleSelectChange = (event) => {
		const { value } = event.target;
		if (value !== "Other") {
			formik.setFieldValue("daysOfAgreement", value);
		}
		setShowCustomInput(value === "Other");
		if (value !== "Other") {
			// Reset custom dates when Other is not selected
			setCustomFromDate(null);
			setCustomToDate(null);
		}
	};

	// Handle fromDate change
	const handleFromDateChange = (date) => {
		setCustomFromDate(date);

		if (date && customToDate) {
			const diff = dayjs(customToDate).diff(dayjs(date), "day");
			formik.setFieldValue("daysOfAgreement", diff > 0 ? diff : 0);
		}
	};

	// Handle toDate change
	const handleToDateChange = (date) => {
		setCustomToDate(date);

		if (customFromDate && date) {
			const diff = dayjs(date).diff(dayjs(customFromDate), "day");
			formik.setFieldValue("daysOfAgreement", diff > 0 ? diff : 0);
		}
	};

	return (
		<>
			<FormControl fullWidth>
				<label style={{ margin: "10px 0" }} htmlFor="daysOfAgreement">
					Term of Agreement:
					<span style={{ color: "red", marginLeft: "5px" }}>*</span>
				</label>
				<Box>
					<Select
						name="daysOfAgreement"
						id="daysOfAgreement"
						displayEmpty
						fullWidth
						sx={{ display: "inline-flex" }}
						value={
							showCustomInput
								? "Other"
								: formik.values.daysOfAgreement
						}
						onChange={handleSelectChange}
					>
						<MenuItem disabled value="">
							<em style={{ color: "grey" }}>
								Select Licensing Term
							</em>
						</MenuItem>
						<MenuItem value={1 * 30}>1 month</MenuItem>
						<MenuItem value={3 * 30}>3 months</MenuItem>
						<MenuItem value={6 * 30}>6 months</MenuItem>
						<MenuItem value={9 * 30}>9 months</MenuItem>
						<MenuItem value={12 * 30}>12 months</MenuItem>
						<MenuItem value={18 * 30}>18 months</MenuItem>
						<MenuItem value={24 * 30}>24 months</MenuItem>
						<MenuItem value={36 * 30}>36 months</MenuItem>
						<MenuItem value={48 * 30}>48 months</MenuItem>
						<MenuItem value={60 * 30}>60 months</MenuItem>
						<MenuItem value="Other">Other</MenuItem>
					</Select>

					{/* Show custom date inputs if "Other" is selected */}
					{showCustomInput && (
						<LocalizationProvider dateAdapter={AdapterDayjs}>
							<Box
								sx={{ display: "inline-flex" }}
								alignItems={"center"}
								gap={4}
							>
								<Box>
									<Box my={2}>
										<label htmlFor="">From</label>
									</Box>
									<DatePicker
										value={customFromDate}
										onChange={handleFromDateChange}
										renderInput={(params) => (
											<TextField
												{...params}
												margin="normal"
												fullWidth
											/>
										)}
									/>
								</Box>
								<Box>
									<Box my={2}>
										<label htmlFor="">To</label>
									</Box>
									<DatePicker
										value={customToDate}
										onChange={handleToDateChange}
										renderInput={(params) => (
											<TextField
												{...params}
												margin="normal"
												fullWidth
											/>
										)}
									/>
								</Box>
							</Box>
						</LocalizationProvider>
					)}
				</Box>
			</FormControl>
			{formik.touched.daysOfAgreement &&
				formik.errors.daysOfAgreement && (
					<Typography sx={{ color: "red" }}>
						{formik.errors.daysOfAgreement}
					</Typography>
				)}
		</>
	);
};

export default LicensingTerm;
